import 'projects/sharedComponents/src/healthSummaryCard/healthSummaryCardList.scss';

import {
  HealthSeverity,
  HealthSummaryCardListFragment,
  HealthSummaryCardListQuickLinkFragment,
} from 'projects/sharedComponents/src/generated/graphql-client-types';

import { Grid } from '@mui/material';
import { HealthSummaryCardItem } from 'projects/sharedComponents/src/healthSummaryCard/healthSummaryCardItem';
import { RenderIf } from 'projects/sharedComponents/src/renderStates/renderIf';

type HealthSummaryCardListProps = {
  healthResults: (HealthSummaryCardListFragment | HealthSummaryCardListQuickLinkFragment)[];
  logoUrl: string;
  severity?: HealthSeverity;
};

export const HealthSummaryCardList: React.FC<HealthSummaryCardListProps> = ({ healthResults, logoUrl, severity }) => {
  return (
    <>
      <Grid item className="healthSummaryCardList">
        {healthResults.map((healthResult, index) => {
          const subText = 'variantText' in healthResult ? healthResult.variantText : undefined;

          return (
            <div key={healthResult.title}>
              <HealthSummaryCardItem
                title={healthResult.title}
                logoUrl={logoUrl}
                ctaLink={healthResult.ctaLink}
                subText={subText}
                severity={severity}
              />
              <RenderIf condition={index < healthResults.length - 1}>
                <hr className="healthSummaryCardList-separator" aria-hidden="true" />
              </RenderIf>
            </div>
          );
        })}
      </Grid>
    </>
  );
};
